import React, { useState, useEffect } from 'react'
import HomeAPI from 'api/HomeAPI'
import TrendingArticlesContainer from 'components/TrendingArticlesContainer/TrendingArticlesContainer'
import isEmpty from 'lodash.isempty'

const HomeStudentArticles = () => {
    const [mainArticle, setMainArticle] = useState(null)
    const [minimalArticles, setMinimalArticles] = useState([])
    const [listArticles, setListArticles] = useState([])
    const [mobileArticles, setMobileArticles] = useState([])

    useEffect(() => {
        HomeAPI.GetArticles().then((response) => {
            setMainArticle(response.data.main_article)
            setMinimalArticles(response.data.minimal_articles)
            setListArticles(response.data.list_articles)
            setMobileArticles(response.data.mobile_articles.slice(0, 2))
        })
    }, [])

    if (isEmpty(mainArticle)) return null

    return (
        <TrendingArticlesContainer
            mainArticle={mainArticle}
            minimalArticles={minimalArticles}
            listArticles={listArticles}
            mobileArticles={mobileArticles}
            titleId='landing_home_student.news.title'
            descriptionId='landing_home_student.news.description'
        />
    )
}

export default HomeStudentArticles
